import useMyProfileStore from "@/hooks/useMyProfileStore";
import useVisitOtherProfileStore from "@/hooks/useVisitOtherProfileStore";
import { Button, Card } from "antd";
import React from "react";
import { HiPencil } from "react-icons/hi";

interface IProfileAboutWidget {
  isVisiting?: boolean;
}

const ProfileAboutWidget: React.FC<IProfileAboutWidget> = ({ isVisiting }) => {
  const { setState, userView } = useMyProfileStore();
  const { user:visitedUser } = useVisitOtherProfileStore();
  return (
    <Card
      title={
        <div className="flex w-full items-center justify-between">
          <h3 className="font-bold text-lg text-white m-0">About {isVisiting ? (visitedUser?.user?.firstName || visitedUser?.user?.lastName) : "Me"}</h3>
          {!isVisiting && (
            <Button
              type="text"
              icon={<HiPencil />}
              onClick={() => setState({ isEditBioModalOpen: true })}
            />
          )}
        </div>
      }
    >
      {isVisiting ? (visitedUser?.user?.bio || "There is no about yet.") : (userView?.user?.bio || "Write some details about yourself.")}
    </Card>
  );
};

export default ProfileAboutWidget;
